
"use client";

import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { motion } from 'framer-motion';
import { Card, CardContent } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';

export default function TermsClient() {
    return (
        <div className="flex flex-col min-h-screen bg-background">
            <Header />
            <main className="flex-grow pt-32 pb-24">
                <div className="container mx-auto px-6 max-w-4xl">
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
                    >
                        <Badge variant="secondary" className="mb-6 px-4 py-1.5 text-[10px] uppercase tracking-[0.3em] font-black">
                            Legal
                        </Badge>
                        <h1 className="font-headline text-5xl md:text-7xl font-black text-foreground mb-12 tracking-tight">
                            Terms of <span className="text-primary italic font-normal">Service</span>
                        </h1>

                        <Card className="bg-card shadow-soft border-none rounded-[2.5rem] p-4 md:p-8">
                            <CardContent className="space-y-10">
                                <div>
                                    <p className="text-lg text-muted-foreground font-medium leading-relaxed">
                                        Welcome to Bay Valley Pups. By accessing our website and inquiring about our puppies, you agree to comply with and be bound by the following terms and conditions. These terms govern the relationship between you (the "Buyer" or "User") and Bay Valley Pups (the "Breeder").
                                    </p>
                                </div>

                                <div className="space-y-4">
                                    <h2 className="text-2xl font-headline font-bold text-foreground">1. Deposits and Reservations</h2>
                                    <p className="text-muted-foreground leading-relaxed">
                                        A non-refundable deposit is required to reserve a puppy. This deposit signifies your intent to purchase and removes the puppy from the market. If you are unable to complete the purchase for any reason, the deposit may be transferred to a future puppy at Bay Valley Pups' discretion, but it will not be refunded.
                                    </p>
                                </div>

                                <div className="space-y-4">
                                    <h2 className="text-2xl font-headline font-bold text-foreground">2. Adoption Process & Screening</h2>
                                    <p className="text-muted-foreground leading-relaxed">
                                        We reserve the right to refuse the sale of a puppy to anyone at any time if we believe the home is not suitable. Our priority is the well-being of our dogs. All applicants must provide accurate information regarding their living situation and ability to care for a dog.
                                    </p>
                                </div>

                                <div className="space-y-4">
                                    <h2 className="text-2xl font-headline font-bold text-foreground">3. Pickup and Delivery</h2>
                                    <p className="text-muted-foreground leading-relaxed">
                                        Puppies must be picked up by the agreed-upon date, typically at 8-10 weeks of age. If a Buyer delays pickup beyond this window without prior agreement, boarding fees may apply. We are not responsible for transport delays if a third-party service (flight nanny) is used.
                                    </p>
                                </div>

                                <div className="space-y-4">
                                    <h2 className="text-2xl font-headline font-bold text-foreground">4. Health Guarantee Reference</h2>
                                    <p className="text-muted-foreground leading-relaxed">
                                        The sale of every puppy is covered by our separate Health Guarantee contract, which outlines specific coverage for genetic conditions and the responsibilities of the Buyer regarding veterinary care. This website's terms do not replace that signed contract.
                                    </p>
                                </div>

                                <div className="space-y-4">
                                    <h2 className="text-2xl font-headline font-bold text-foreground">5. Intellectual Property</h2>
                                    <p className="text-muted-foreground leading-relaxed">
                                        All content on this website, including text, logos, and images of our dogs, is the property of Bay Valley Pups and may not be used, reproduced, or distributed without express written permission.
                                    </p>
                                </div>
                            </CardContent>
                        </Card>
                    </motion.div>
                </div>
            </main>
            <Footer />
        </div>
    );
}
